import { Button, useModal } from '../../../../../../components'
import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { TermoFormModal } from '../../../termos-create/TermoFormModal'
import { useQueryResponse } from '../../../core/QueryResponseProvider'

export const TermosListToolbar = () => {
  const { showModal } = useModal()
  const { refetch } = useQueryResponse()

  const openModal = () =>
    showModal({
      title: 'Cadastrar Novo Termo de Consentimento',
      content: <TermoFormModal onSuccess={refetch} />,
      size: ModalSize.Large,
    })

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openModal}>
      Nova versão
    </Button>
  )
}
